import {Box} from '@mui/material';
import {FC} from 'react';
import {TabPanelProps} from './TabPanel.types';

export const TabPanel: FC<TabPanelProps> = ({children, value, index, ...other}) => {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Box>
    );
};
